import { ProjectSectionUnit } from './project-section-unit.model';
import { ProjectSectionUnitFormInfo } from './project-section-unit-form-info.model';
import { ProjectSectionUnitStatus } from './project-section-unit-status.enum';
import { ProjectSectionUnitSubStatus } from './project-section-unit-sub-status.enum';
export class ProjectSectionUnitProgress extends ProjectSectionUnit {
  progressId?: number;
  planId?: number;
  status?: ProjectSectionUnitStatus;
  subStatus?: ProjectSectionUnitSubStatus;
  startDate?: number;
  startDateClz?: string;
  finishDate?: number;
  finishDateClz?: string;
  realDateDisplay?: string;
  days?: number;
  actualComment?: string;
  planStartDate?: number;
  planStartDateDate?: Date;
  planFinishDate?: number;
  planFinishDateDate?: Date;
  planFinishDateClz?: string;
  planDateDisplay?: string;
  planDays?: number;
  planStartDateFlag?: boolean;
  planFinishDateFlag?: boolean;
  constructionForms?: Array<ProjectSectionUnitFormInfo>;
  constructionFormCount?: number;
  constructionFormUploadedCount?: number;
  constructionSelfForms?: Array<ProjectSectionUnitFormInfo>;
  constructionSelfFormCount?: number;
  constructionSelfFormUploadedCount?: number;
  superviseSpotForms?: Array<ProjectSectionUnitFormInfo>;
  superviseSpotFormCount?: number;
  superviseSpotFormUploadedCount?: number;
  superviseRecordForms?: Array<ProjectSectionUnitFormInfo>;
  superviseRecordFormCount?: number;
  superviseRecordFormUploadedCount?: number;
  jgSpotFormCount?: number;
  jgSpotFormUploadedCount?: number;
  constructionFormCompleted?: boolean;
  constructionSelfFormCompleted?: boolean;
  superviseSpotFormCompleted?: boolean;
  superviseRecordFormCompleted?: boolean;
  planComment?: string;
  // 前端自用
  constructionFormsAddable?: Array<ProjectSectionUnitFormInfo>;
  constructionSelfFormsAddable?: Array<ProjectSectionUnitFormInfo>;
  superviseSpotFormsAddable?: Array<ProjectSectionUnitFormInfo>;
  superviseRecordFormsAddable?: Array<ProjectSectionUnitFormInfo>;
  constructionFormsForceCount?: number;
  constructionFormsFinishCount?: number;
  constructionFormsHasForce?: boolean;
  constructionSelfFormsForceCount?: number;
  constructionSelfFormsFinishCount?: number;
  constructionSelfFormsHasForce?: boolean;
  superviseSpotFormsForceCount?: number;
  superviseSpotFormsFinishCount?: number;
  superviseSpotFormsHasForce?: boolean;
  superviseRecordFormsForceCount?: number;
  superviseRecordFormsFinishCount?: number;
  superviseRecordFormsHasForce?: boolean;
  // group
  formGroupKey?: string;
  formGroup?: {
    [key: string]: {
      constructionForms?: Array<ProjectSectionUnitFormInfo>;
      constructionSelfForms?: Array<ProjectSectionUnitFormInfo>;
      superviseRecordForms?: Array<ProjectSectionUnitFormInfo>;
      superviseSpotForms?: Array<ProjectSectionUnitFormInfo>;
    };
  };
  tag?: string;
  unitCascaderValue?: any[];
}
